var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStripeBank = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "stripe-bank_svg__svg-safari-fix",
  viewBox: "0 0 16 16",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5 7.5V14h1.5V7.5h3V14H11V7.5h3V14h1a1 1 0 0 1 1 1v1H0v-1a1 1 0 0 1 1-1h1V7.5zM8 0a1385 1385 0 0 1 7.5 4.134A1 1 0 0 1 14.98 6H1.02A1 1 0 0 1 .5 4.134Q.98 3.858 8 0",
  clipRule: "evenodd"
})));
export default SvgStripeBank;